const SearchDatas = ["title", "description", "badge", "author"];
export default SearchDatas;
